import { load, remove } from 'react-cookies';

// Re-evaluate cookie state each time instead of capturing a stale boolean at import time.
export const isLogged = () => Boolean(load('--access-token--'));

export const removeSavedTokens = () => {
  remove('--access-token--', { path: '/' });
  remove('--refresh-token--', { path: '/' });
};
